import React from 'react';

function Trending() {
  return (
    <div className='trending row'>
      <div>
        <h2 className='col-sm'>
          Trending <div>Today</div>
        </h2>
      </div>
      <div className='trendingLine col-sm' />
      <p className='col-sm'>
        Lorem ipsum dolor sit amet, consectetuer adipiscing ligula eget dolor.
      </p>
      <div className='trendingLine col-sm' />
      <p className='col-sm'>
        Lorem ipsum dolor sit amet, consectetuer adipiscing ligula eget dolor.
      </p>
      <div className='trendingLine col-sm' />
      <p className='col-sm'>
        Lorem ipsum dolor sit amet, consectetuer adipiscing ligula eget dolor.
      </p>
    </div>
  );
}

export default Trending;
